import { render, staticRenderFns } from "./role_dep_select.vue?vue&type=template&id=6c350cb2"
import script from "./role_dep_select.vue?vue&type=script&lang=js"
export * from "./role_dep_select.vue?vue&type=script&lang=js"
import style0 from "./role_dep_select.vue?vue&type=style&index=0&id=6c350cb2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports